module.exports = __webpack_public_path__ + "img/SELFEE_120X35.fdd9e08c.png";